module.exports = __webpack_public_path__ + "img/tpc-printable-flyers-2.d7bc69e0.webp";